export default (type = 'btn', data = {}) => {
  try {
    let payload = data
    console.log('埋点', data)
    tracking.event(type, JSON.stringify(payload))
  }
  catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/utils/dataTracking.js